<template>
  <div id="box">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="$t('conformation.title')" />
        <Countdown
          :expiration="requestInfo.expiration"
          @expired="expired"
          v-if="requestInfo.expiration != 0"
        />
        <p v-html="$t('conformation.description')" class="description" />
        <div class="expandWrapper">
          <OTP :code="requestInfo.otp" v-if="requestInfo.otp != ''" />
        </div>
      </div>
      <div class="wrapper">
        <CustomButton
          :isSingle="!isMob"
          :buttonType="'accent'"
          :customButtonTxt="$t('customButton.cancel')"
          @submit="cancel"
        />
        <CustomButton
          :isSingle="false"
          :buttonType="'primary'"
          :customButtonTxt="$t('customButton.app')"
          @submit="directAPP"
          v-if="isMob"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
import Countdown from "../components/countdown.vue";
import OTP from "../components/otp.vue";
import { isMobileOnly } from "mobile-device-detect";

export default {
  name: "ConfirmOTP",
  components: {
    CustomButton,
    Countdown,
    OTP,
  },
  props: {
    requestInfo: {
      type: Object,
    },
  },
  data() {
    return {
      isMob: isMobileOnly,
    };
  },
  methods: {
    directAPP() {
      window.location.href =
        process.env.VUE_APP_SCHEMEPATH + "xid.me/browserLaunch";
    },
    cancel() {
      this.$emit("clearStatusTimer");
      this.$emit("cancel");
      this.$emit("navigate", { page: "Error", errorType: "canceled" });
    },
    expired() {
      this.$emit("clearStatusTimer");
      this.$emit("navigate", { page: "Error", errorType: "expired" });
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
  .wrapper
    +flex(space-between, center, row)
</style>
